export function formatDateWithTime(
	isoDateString: string | null | undefined
): string {
	if (!isoDateString || typeof isoDateString !== "string") {
		return "Date Not Available";
	}

	const date = new Date(isoDateString);

	if (Number.isNaN(date.getTime())) {
		return "Invalid Date";
	}

	const day = date.toLocaleString("en-GB", { day: "2-digit" });
	const month = date.toLocaleString("en-GB", { month: "short" });
	const year = date.getFullYear();
	const time = date.toLocaleTimeString("en-GB", { hour12: false });

	return `${day}, ${month} ${year}, ${time}`;
}
